var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mega-menu-region" },
    [
      _vm._t("mega-header"),
      _vm._v(" "),
      _c("div", { staticClass: "mega-menu-content" }, [
        _c("div", { staticClass: "content-container" }, [
          _c("div", { staticClass: "mega-menu-inner-row" }, [
            _c(
              "div",
              { staticClass: "mega-menu-inner-content" },
              [
                _c(
                  "div",
                  {
                    staticClass: "mega-menu-nav-region",
                    style: _vm.displayGridSize,
                  },
                  _vm._l(_vm.menus, function (menu, index) {
                    return _c(
                      "div",
                      {
                        key: `menu-layout-${menu.id}-${index}`,
                        staticClass: "menu-column",
                      },
                      [
                        menu.type === "container"
                          ? _c("menuBlock", {
                              attrs: {
                                list: menu.columns,
                                title: menu.linkText,
                              },
                              on: {
                                "close-dropdown": function ($event) {
                                  return _vm.$emit("close-dropdown")
                                },
                              },
                            })
                          : _c("HighlightButton", {
                              attrs: {
                                url: menu.linkUrl,
                                "router-link": true,
                                title: menu.linkText,
                                "button-type": "default",
                                "url-new-window": menu.linkTarget === "_blank",
                              },
                              on: {
                                "highlight-button-click": function ($event) {
                                  return _vm.$emit("close-dropdown")
                                },
                              },
                            }),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("ButtonBlock", { attrs: { content: _vm.actions } }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.ctas && _vm.ctas.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "mega-menu-cta-region",
                    style: _vm.displayBlockWidth,
                  },
                  [
                    _c("div", { staticClass: "mega-menu-cta-title-region" }, [
                      _c("h4", { staticClass: "title" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.ctasConfig.groupHeading) +
                            "\n            "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("GridDisplayAspect", {
                      attrs: {
                        content: _vm.ctas,
                        "grid-item-width": parseInt(
                          _vm.ctasConfig.gridItemWidth
                        ),
                        "grid-gap": _vm.ctasConfig.gridGap,
                        "row-sizing": _vm.ctasConfig.gridRowSizing,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }